(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-acc-form"] && !Shopify.designMode) return;
  try {
    
  function focusAccHeading() {
    if (window.location.hash !== '#acc-form') return;
    document.getElementById('acc-form-heading')?.focus({ preventScroll: true });
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#acc-form"]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    requestAnimationFrame(focusAccHeading);
  });
  window.addEventListener('hashchange', focusAccHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-article-main"] && !Shopify.designMode) return;
  try {
    
  function initialiseMealPrepArticle() {
    const content = document.querySelector('[data-mpa-content]');
    const toc = document.querySelector('[data-mpa-toc]');
    const list = document.querySelector('[data-mpa-toc-list]');
    if (!content || !toc || !list || content.dataset.mpaReady) return;
    content.dataset.mpaReady = 'true';
    const headings = [...content.querySelectorAll('h2')].filter(
      (heading) => !heading.closest('.tfk-hero, .tfk-shop, .tfk-end, .tfk-rel')
    );
    list.replaceChildren();
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase()
          .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (document.getElementById(id)) id = `${base}-${suffix++}`;
        heading.id = id;
      }
      heading.tabIndex = -1;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });
    toc.hidden = headings.length < 2;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseMealPrepArticle, { once: true });
  } else {
    initialiseMealPrepArticle();
  }
  document.addEventListener('shopify:section:load', initialiseMealPrepArticle);

  } catch(e) { console.error(e); }
})();
})();
